<template>
  <div id="app">
    <Navbar/>
    <Titlebar v-if="isShowTitle" :title="title"/>
    <Messagebar class="sticky-title"/>
    <router-view class="view-margin" @updateTitle="updateTitle($event)"/>
    <Fotter/>
    <Loading/>
  </div>
</template>

<script>
import { Component, Vue, Emit } from 'vue-property-decorator';
import Navbar from '@/components/navigation/Navbar.vue';
import Fotter from '@/components/fotter/Fotter';
import Titlebar from '@/components/title/Titlebar';
import Messagebar from '@/components/alert/Messagebar';
import Loading from '@/components/common/Loading';

@Component({
  components: {
    Navbar,
    Titlebar,
    Messagebar,
    Fotter,
    Loading,
  },
})

export default class App extends Vue {
  title = '';
  isShowTitle = false;

  updateTitle(title) {
    this.title = title;
    this.showTitle((this.title !== null && this.title !== ''));
  }

  showTitle(isShow) {
    this.isShowTitle = isShow;
  }
}
</script>

<style scoped>
.view-margin {
  margin: 1rem 1rem 1rem 1rem;
}
.sticky-title {
  position: sticky;
}
</style>
